<template>
  <div class="template">
    <div class="top-title">维修补偿保障服务合同</div>
    <div class="num-con">
      编号：
      <span class="num">{{showDate.saleslip.pnum}}</span>
    </div>
    <table class="temTable" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td>
          <div class="key">一.服务期限：</div>
          <div
            class="p-content"
          >自服务合同生效之日起{{swapper(selectYear)}}年有效。在保障期限内，如发生车辆转让，原保障责任立即中止，且应立即通知本公司办理变更手续。变更手续办理的次日零时起，保障责任恢复，但原服务函终止日期不变。保障责任中止期间本公司不负责赔偿。</div>
        </td>
      </tr>
      <tr>
        <td>
          <span class="key">二.服务区域：</span>中华人民共和国境内(不含港、澳、台)
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">三.保障责任：</div>
          <div class="p-content">
            保障期限内，已安装和使用了该产品的车辆在机动车在发生意外事故后，回到经销商处维修，即可按照定损金额获得相应的维修津贴补偿（事故责任判定不影响索赔）。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">四.除外责任：</div>
          <div class="p-content">
              服务商对下列各项不承担补偿责任：<br>
              1、在服务承诺期间内，车辆被改装或拼装；2、被他人诈骗造成全车或部分损失；3、用于以下活动的车辆不在承保范围之内：<br>
（1）长期租赁（包括租借）、出租车、短期租贷车;（2）竞赛、集会、驾驶学校;（3）快递、送货;
（4）拖载或货物运输;（5）公共服务、包括警察、消防队、救护车;（6）网约车。
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="key">五.赔偿处理：</div>
          <div class="p-content">
           （一）维修补偿服务：<br>
一、保障范围<br>
1、服务范围<br>
服务期限内，本合同载明的机动车在发生意外事故后，回到经销商处维修，即可按照定损金额获得相应的维修津贴补偿（事故责任判定不影响索赔）。<br>
2、事故类型<br>
保险公司出险定损后的车辆事故。<br>
二、赔偿约定<br>
1、赔偿价格
          </div>
<table class="personal-table" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td >车价区间</td>
        <td >2000≤定损金额≤2万元</td>
        <td >2万元&lt;定损金额≤5万元</td>
        <td >定损金额>5万元</td>
        <td >累计补偿限额</td>
      </tr>
      <tr>
        <td >车价≤35万</td>
        <td >定损金额的10%，最高1000元</td>
        <td >2000元</td>
        <td >3000元</td>
        <td >3000元</td>
      </tr>
      <tr><td >
        35万＜车价≤55万</td>
        <td >定损金额的10%，最高1200元</td>
        <td >2400元</td>
        <td >3500元</td>
        <td >3500元</td>
        </tr>
        <tr><td >
          55万＜车价≤85万</td>
        <td >定损金额的10%，最高1400元</td>
        <td >2800元</td>
        <td >4000元</td>
        <td >4000元</td>
        </tr>
        <tr><td >
85万＜车价≤200万</td>
        <td >定损金额的10%，最高1600元</td>
        <td >3200元</td>
        <td >4500元</td>
        <td >4500元</td>
        </tr>
    </table>
    <div class="p-content">
    车辆开票价格&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{showDate.saleslip.compensation}}&nbsp;&nbsp;&nbsp;&nbsp;元。</div>
      <div class="p-content">（二）车辆补漆服务：<br>
      一、保障范围<br>
      1、服务范围<br>
服务期间内，本合同载明的机动车在使用过程中，发生无明显碰撞痕迹的划痕车身油漆损失，在有效期限内向服务商提出损害补偿请求的，服务商依据合同的约定在补偿限额内提供维修服务。<br>
2、事故类型<br>
发生无明显碰撞痕迹的划痕车身油漆损失。<br>
二、赔偿约定<br>
1、赔偿价格<br>
所有赔偿以服务或实物形式进行兑现。如果费用超过每次赔偿限额，超过部分费用由用户自行承担。
      </div>
<table class="personal-table" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td>车价区间</td>
        <td>单次补偿限额（元）</td>
        <td>累计补偿限额（元）</td>
        </tr>
        <tr><td>车价≤35万</td>
        <td>400</td>
        <td>800</td>
        </tr>
        <tr><td>35万＜车价≤55万</td>
        <td>600</td>
        <td>1200</td>
        </tr>
        <tr><td>55万＜车价≤85万</td>
        <td>800</td>
        <td>1600</td>
        </tr>
        <tr><td>85万＜车价≤200万</td>
        <td>1000</td>
        <td>2000</td>
        </tr>
        </table>
        <div class="p-content">注：新车每次事故限补偿1幅油漆。</div>
      </td>
      </tr>
      <tr>
        <td>
          <div class="key">六.赔付材料：</div>
          <div class="p-content">
1、购买及安装本产品的凭证、交费凭证；2、合同载明车辆的行驶证，购车发票复印件；3、机动车辆保险单、车险理赔定损单；4、机动车整车、前挡风车架号特写、受损点特写、修复后全貌等照片；5、其他相关材料。 
          </div>
      </td>
      </tr>
    </table>
    <div class="personal-title">车辆信息</div>
    <table class="personal-table" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td width="130">车主姓名</td>
        <td colspan="2">{{showDate.saleslip.customername}}</td>
        <td width="130">证件号码</td>
        <td colspan="2">{{showDate.saleslip.certificatenum}}</td>
      </tr>
      <tr>
        <td>固定电话</td>
        <td colspan="2"></td>
        <td>移动电话</td>
        <td colspan="2">{{showDate.saleslip.phone}}</td>
      </tr>
      <tr>
        <td>联系地址</td>
        <td colspan="2">{{showDate.saleslip.address}}</td>
        <td>证明函金额</td>
        <td colspan="2">{{showDate.saleslip.policyamount}}</td>
      </tr>
      <tr>
        <td>车牌号码</td>
        <td>{{showDate.saleslip.carnum}}</td>
        <td width="130">车架号</td>
        <td>{{showDate.saleslip.frame}}</td>
        <td width="130">车辆登记日期</td>
        <td>{{this.$formatTimeCN(showDate.saleslip.buytime, 'yyyy-MM-dd')}}</td>
      </tr>
      <tr>
        <td>发动机号</td>
        <td>{{showDate.saleslip.enginenum}}</td>
        <td>产品编号</td>
        <td>{{showDate.saleslip.devicenum}}</td>
        <td>安装日期</td>
        <td>{{this.$formatTimeCN(showDate.saleslip.installtime)}}</td>
      </tr>
      <tr>
        <td>安装地点</td>
        <td colspan="3">{{showDate.saleslip.installaddress}}</td>
        <td>安装人员</td>
        <td>{{showDate.saleslip.installman}}</td>
      </tr> 
      <tr>
        <td>服务期限</td>
        <td colspan="5">自{{this.$formatTimeCN2(showDate.saleslip.installtime)}}至{{getendTime($formatTimeCN2(showDate.saleslip.pstarttime))}}止</td>
      </tr>
    </table>
    <p
      class="tips"
    >产品销售公司：(签章)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;车主签名：</p>
    <p class="tips">有效期:{{getendTime($formatTimeCN2(showDate.saleslip.pstarttime))}}</p>
    <p class="tips">全国统一客服热线：4006601517</p>
  
    <img class="inis-1" src="@/assets/images/inis.png" alt />
  </div>
</template>

<script>
export default {
  props: ["showDate", "selectYear"],
  data() {
    return {};
  },
  mounted() {
    // this.ini ()
  },
  methods: {
    swapper(n) {
      switch (n) {
        case 1:
          return "壹";
        case 2:
          return "贰";
        case 3:
          return "叁";
        case 4:
          return "肆";
        case 5:
          return "伍";
      }
    },
    getendTime(str) {
      str = str.split("年");
      let tempdata = Number(str[0]);
      str[0] = tempdata += this.selectYear;
      return str.join("年");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/template/w1.vue